import React from "react";
import { useNavigate } from "react-router-dom";
import blurLoading from "../assets/images/blurLoading.png";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[url('assets/images/bgLoading.jpg')] bg-cover bg-fixed bg-center min-h-screen relative flex items-center justify-center px-4 overflow-hidden">
      
      {/* Blur effect at the bottom left */}
      <img
        src={blurLoading}
        alt="blurLoading"
        className="absolute bottom-0 left-0 pointer-events-none"
      />

      <div className="text-center relative z-10 max-w-lg mb-20 bg-black/40 p-10 rounded-2xl backdrop-blur-sm border border-[#FBE67B]/20">
        {/* 404 Number */}
        <h1 className="text-[10rem] md:text-[12rem] font-black leading-none text-[#FBE67B] select-none drop-shadow-2xl mb-4">
          404
        </h1>

        {/* Message */}
        <h2 className="text-2xl md:text-3xl font-semibold text-white mb-3">
          Trang không tồn tại
        </h2>
        <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
          Trang bạn đang tìm kiếm không tồn tại hoặc đã được di chuyển sang
          địa chỉ khác.
        </p>

        {/* Back to Home button */}
        <button
          onClick={() => navigate("/")}
          className="group relative inline-flex items-center gap-2 px-8 py-3.5 bg-[#FBE67B] text-black font-semibold rounded-full shadow-lg shadow-[#FBE67B]/25 hover:shadow-[#FBE67B]/40 transition-all duration-300 hover:scale-105 active:scale-95"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 transition-transform duration-300 group-hover:-translate-x-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Trở về trang chủ
        </button>
      </div>
    </div>
  );
};

export default NotFound;
